import React, { useCallback, useEffect, useState } from "react";
import { get, set } from "lodash";
import T from "prop-types";
import api from "APP_ROOT/api";
import {
  Modal,
  Header,
  Body,
  Footer,
  Close
} from "MODULES/shared/components/Modal";
import { TIER_TO_STAR_MAP, TIER_TYPES } from "MODULES/parts/constants";
import { Form as AppForm } from "MODULES/shared/components/Forms";
import { getPartNumberColorClassNameByTierType } from "MODULES/shared/helpers";
import {
  PURCHASE_ORDER_BCC_EMAILS,
  SETTINGS,
  TIER_TYPE_WARNING_LIMITS
} from "APP_ROOT/constants";
import Stars from "MODULES/shared/components/Stars/Stars";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";

function TierTypeWarningModal({
  closed,
  close,
  editing,
  saveSetting,
  settings,
  setSettings,
  tierTypeLimits = [],
  submitting = false,
  updateTierTypeLimits
}) {
  if (closed) {
    return null;
  }

  const [partCounts, setPartCounts] = useState({});
  useEffect(() => {
    api.parts.tierTypeStats().then(({ data }) => {
      setPartCounts(data);
      return function cleanup() {};
    });
  }, []);

  const renderRow = (row, idx) => (
    <tr>
      <td className={getPartNumberColorClassNameByTierType(row.tier)}>
        <Stars tierType={row.tier} />
        <span style={{ color: "white" }}>
          <strong>{partCounts[TIER_TO_STAR_MAP[row.tier]]}</strong>
        </span>
      </td>
      <td>
        <input
          className="form-control"
          type="number"
          step={0.01}
          value={get(tierTypeLimits, `[${idx}].cost`)}
          onChange={e => updateTierTypeLimits(`[${idx}].cost`, e.target.value)}
        />
      </td>
      <td>
        <input
          className="form-control"
          type="number"
          step={1}
          value={get(tierTypeLimits, `[${idx}].qty`)}
          onChange={e => updateTierTypeLimits(`[${idx}].qty`, e.target.value)}
        />
      </td>
      <td>
        <input
          className="form-control"
          type="number"
          step={0.01}
          value={get(tierTypeLimits, `[${idx}].percent_adjustment`)}
          onChange={e =>
            updateTierTypeLimits(`[${idx}].percent_adjustment`, e.target.value)}
        />
      </td>
    </tr>
  );

  return (
    <Modal open={editing} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Purchase Admin Controls</h4>
      </Header>
      <Body>
        <table className="table table-striped table-hover table-numbered">
          <thead>
            <tr>
              <th>Tier Type</th>
              <th>Restriction ($) Limit (&lt;=)</th>
              <th>Total Sellable Qty Restriction Limit (&lt;=)</th>
              <th>% Adjustment</th>
            </tr>
          </thead>
          <tbody>{tierTypeLimits.map(renderRow)}</tbody>
        </table>
        <FormRow>
          <Col md={12}>
            <label
              className="control-label"
              htmlFor={PURCHASE_ORDER_BCC_EMAILS}
            >
              Purchase Order BCC Emails
            </label>
            <input
              name={PURCHASE_ORDER_BCC_EMAILS}
              className="form-control"
              value={get(settings, PURCHASE_ORDER_BCC_EMAILS)}
              onChange={e => {
                settings[PURCHASE_ORDER_BCC_EMAILS] = e.target.value;
                setSettings(settings);
              }}
            />
          </Col>
        </FormRow>
      </Body>
      <Footer>
        <AppForm.Cancel close={close} editable />
        <AppForm.Submit
          disabled={false}
          editable
          submitting={submitting}
          onClick={() => {
            saveSetting();
            close();
          }}
        />
      </Footer>
    </Modal>
  );
}

TierTypeWarningModal.propTypes = {
  editing: T.bool,
  closed: T.bool,
  close: T.func.isRequired,
  saveSetting: T.func.isRequired,
  tierTypeLimits: T.shape({}),
  settings: T.shape({}),
  setSettings: T.func,
  submitting: T.bool.isRequired,
  updateTierTypeLimits: T.func.isRequired
};

export default function TierTypeWarningMgmt() {
  const [tierTypeLimits, setTierTypeLimits] = useState([]);
  const [closed, toggle] = useState(true);
  const [settings, setSettings] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [changes, setChanges] = useState(0);

  useEffect(() => {
    api.appSetting.index().then(({ data }) => {
      setTierTypeLimits(
        get(data, TIER_TYPE_WARNING_LIMITS) ||
          TIER_TYPES.map(tier => ({ tier }))
      );

      setSettings(get(data, SETTINGS));

      return function cleanup() {};
    });
  }, []);

  const saveSetting = useCallback(() => {
    setSubmitting(true);
    api.appSetting
      .update({
        tier_type_warning_limits: tierTypeLimits,
        settings
      })
      .then(({ data: resp }) => {
        setSubmitting(false);
        setSettings(get(resp, SETTINGS));
        setTierTypeLimits(
          get(resp, TIER_TYPE_WARNING_LIMITS) ||
            TIER_TYPES.map(tier => ({ tier }))
        );
      });
  });

  const updateTierTypeSetting = useCallback(
    (path, value) => {
      setTierTypeLimits(set(tierTypeLimits, path, value));
      setChanges(changes + 1);
    },
    [tierTypeLimits, changes]
  );

  return (
    <React.Fragment>
      <a style={{ cursor: "pointer" }} onClick={() => toggle(!closed)}>
        Purchase Admin Controls
      </a>
      <TierTypeWarningModal
        editing={!closed}
        close={() => toggle(true)}
        settings={settings}
        tierTypeLimits={tierTypeLimits}
        saveSetting={saveSetting}
        setSettings={setSettings}
        submitting={submitting}
        updateTierTypeLimits={updateTierTypeSetting}
        changes={changes}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./app/modules/Admin/TierTypeWarningMgmt/TierTypeWarningMgmt.jsx